var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgResourceIcon = function SvgResourceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "noun-information-964399",
    d: "M10 7.828h1.739v9.567H10Zm.87-3.479a1.3 1.3 0 1 0 1.3 1.3 1.281 1.281 0 0 0-1.298-1.3Zm10.872 6.523A10.872 10.872 0 1 1 10.872 0a10.876 10.876 0 0 1 10.871 10.872Zm-1.739 0A9.132 9.132 0 1 0 10.872 20 9.131 9.131 0 0 0 20 10.872Z"
  })));
};
export default SvgResourceIcon;